import {FieldValues, useFormState} from 'react-hook-form';

/**
 * This works with react-hook-form only
 * https://react-hook-form.com/api/useform/formstate
 */
const useFormEnableSubmit = <FormValues extends FieldValues = FieldValues>() => {
    const {isValidating, isSubmitting, isValid} = useFormState<FormValues>();
    return !isValidating && !isSubmitting && isValid;
};

export default useFormEnableSubmit;
